$(function () {
    if ($('.botcard') && $('.botcard').length > 0) {
        $(".botcard").each(function (index, item) {
            var fillBackground = $(item).attr("data-background-img");
            $(item).css("background-image", `url('${fillBackground}')`);
        })
    }
});